var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { ENV_LIT_NETWORK, getUrls } from '@shared/utils/config/environment';
import { createTDBOrder } from '@/lib/db/DBOrderHelpers';
import { createDBOrderHistory } from '@/lib/db/DBOrderHistoryHelpers';
import { executeDirectTransactionsEVM } from '@shared/utils/evm/base/executeDirectTransactionsEVM';
import { simulateEVMTransactionsClient } from '@/lib/simulateEVMTransactionsClient';
import { deepConvertBigInt } from '@shared/utils/off-chain/deep-convert-bigint';
import { ChainId } from '@shared/utils/config/networks';
import { hash } from 'crypto';
export default function executeViaClientEVM(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var tokenPrices, toAssetPriceData, dbOrderType, result, dbOrder, _c, startTime, executionResponse, simulateResult, decodedResponse, paramsToUse, approvalTransactions, swapTransactions, executionResponseError, e_1, approvalHash_1, executionHash, paramsToUse, allowanceTransactions, swapTransaction, executionResponseError, e_2, approvalHash_2, executionResponseHash, executionTime, dbOrderHistory, executorUrl, updateUrl, e_3;
        var _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        var params = _b.params, pkp = _b.pkp, orderType = _b.orderType, dbOrderParams = _b.dbOrderParams, signer = _b.signer, existingdbOrder = _b.existingdbOrder, additionalDecodedResponse = _b.additionalDecodedResponse, additionalExecutionTime = _b.additionalExecutionTime, skipSimulation = _b.skipSimulation;
        return __generator(this, function (_u) {
            switch (_u.label) {
                case 0:
                    _u.trys.push([0, 20, , 21]);
                    tokenPrices = dbOrderParams === null || dbOrderParams === void 0 ? void 0 : dbOrderParams.tokenPrices;
                    toAssetPriceData = dbOrderParams === null || dbOrderParams === void 0 ? void 0 : dbOrderParams.toAssetPriceData;
                    dbOrderType = dbOrderParams === null || dbOrderParams === void 0 ? void 0 : dbOrderParams.dbOrderType;
                    result = {
                        message: "".concat(orderType, " client execution called"),
                    };
                    if (!existingdbOrder) return [3 /*break*/, 1];
                    _c = existingdbOrder;
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, createTDBOrder({
                        cloud_wallet_address: pkp.additionalEthAddress,
                        order: params,
                        pkp: pkp,
                        token_prices: tokenPrices,
                        order_type: dbOrderType,
                        pkp_eth_address: pkp === null || pkp === void 0 ? void 0 : pkp.ethAddress,
                    })];
                case 2:
                    _c = (_u.sent()).data;
                    _u.label = 3;
                case 3:
                    dbOrder = _c;
                    console.log('Executing order EVM dbOrder=>', dbOrder);
                    startTime = new Date().getTime();
                    executionResponse = void 0;
                    simulateResult = void 0;
                    decodedResponse = void 0;
                    if (!(orderType == 'SWAP_DLN' || orderType == 'SWAP_OKX')) return [3 /*break*/, 10];
                    paramsToUse = (params === null || params === void 0 ? void 0 : params.results)
                        ? params.results.map(function (x) { return x.transactions; })
                        : [(_d = params === null || params === void 0 ? void 0 : params.result) === null || _d === void 0 ? void 0 : _d.transactions];
                    approvalTransactions = (paramsToUse === null || paramsToUse === void 0 ? void 0 : paramsToUse.some(function (x) { return x.allowance && x.allowance.length; }))
                        ? (_e = paramsToUse === null || paramsToUse === void 0 ? void 0 : paramsToUse.map(function (x) { return x === null || x === void 0 ? void 0 : x.allowance; })) === null || _e === void 0 ? void 0 : _e.flat().filter(function (x) { return x; })
                        : [];
                    swapTransactions = paramsToUse === null || paramsToUse === void 0 ? void 0 : paramsToUse.map(function (x) { return x === null || x === void 0 ? void 0 : x.swap; }).filter(function (x) { return x; });
                    if (!(swapTransactions === null || swapTransactions === void 0 ? void 0 : swapTransactions.length)) {
                        throw new Error('Quote Generation Error');
                    }
                    console.log("Executing order EVM ".concat(orderType, " client side"), approvalTransactions, swapTransactions);
                    if (!!skipSimulation) return [3 /*break*/, 5];
                    return [4 /*yield*/, simulateEVMTransactionsClient({
                            network: swapTransactions[0].chainId,
                            transactions: __spreadArray(__spreadArray([], approvalTransactions, true), swapTransactions, true),
                        })];
                case 4:
                    simulateResult = _u.sent();
                    console.log("Executing order EVM ".concat(orderType, " client side simuations"), simulateResult, swapTransactions);
                    if (!(simulateResult === null || simulateResult === void 0 ? void 0 : simulateResult.simsPassed) || (simulateResult === null || simulateResult === void 0 ? void 0 : simulateResult.status) == 'error') {
                        throw new Error("Simulation Error: ".concat(simulateResult === null || simulateResult === void 0 ? void 0 : simulateResult.error));
                    }
                    _u.label = 5;
                case 5:
                    delete swapTransactions[0].from;
                    approvalTransactions.forEach(function (x) {
                        delete x.from;
                    });
                    swapTransactions[0].value = BigInt(swapTransactions[0].value);
                    executionResponseError = null;
                    _u.label = 6;
                case 6:
                    _u.trys.push([6, 8, , 9]);
                    return [4 /*yield*/, executeDirectTransactionsEVM({
                            transactions: __spreadArray(__spreadArray([], approvalTransactions, true), swapTransactions, true),
                            network: (_f = swapTransactions === null || swapTransactions === void 0 ? void 0 : swapTransactions[0]) === null || _f === void 0 ? void 0 : _f.chainId,
                            wallet: signer,
                            blockConfirmations: 0,
                            legacyPayloads: __spreadArray(__spreadArray([], approvalTransactions === null || approvalTransactions === void 0 ? void 0 : approvalTransactions.map(function (x) {
                                if (x.chainId == ChainId.ETHEREUM || true) {
                                    return {
                                        gasPrice: x.gasPrice,
                                        gasLimit: x.gasLimit,
                                    };
                                }
                                else {
                                    return undefined;
                                }
                            }), true), [
                                ((_g = swapTransactions === null || swapTransactions === void 0 ? void 0 : swapTransactions[0]) === null || _g === void 0 ? void 0 : _g.chainId) == ChainId.ETHEREUM || true
                                    ? {
                                        gasPrice: swapTransactions[0].gasPrice,
                                        gasLimit: swapTransactions[0].gasLimit,
                                    }
                                    : undefined,
                            ], false).filter(function (x) { return x; }),
                        })];
                case 7:
                    executionResponse = _u.sent();
                    if (!((_h = executionResponse === null || executionResponse === void 0 ? void 0 : executionResponse[0]) === null || _h === void 0 ? void 0 : _h.transactionHash)) {
                        throw new Error("Error executing transaction");
                    }
                    return [3 /*break*/, 9];
                case 8:
                    e_1 = _u.sent();
                    executionResponseError = e_1.message;
                    return [3 /*break*/, 9];
                case 9:
                    approvalHash_1 = (approvalTransactions === null || approvalTransactions === void 0 ? void 0 : approvalTransactions.length)
                        ? (_j = executionResponse === null || executionResponse === void 0 ? void 0 : executionResponse[0]) === null || _j === void 0 ? void 0 : _j.transactionHash
                        : null;
                    executionHash = ((_k = executionResponse === null || executionResponse === void 0 ? void 0 : executionResponse[1]) === null || _k === void 0 ? void 0 : _k.transactionHash) || ((_l = executionResponse === null || executionResponse === void 0 ? void 0 : executionResponse[0]) === null || _l === void 0 ? void 0 : _l.transactionHash);
                    console.log('Executing order EVM hashes', approvalHash_1, executionHash, executionResponse);
                    decodedResponse = {
                        type: orderType,
                        status: executionResponseError ? 'error' : 'success',
                        error: executionResponseError,
                        note: 'Client side execution',
                        quoteId: params.quoteId,
                        quote: params,
                        swapTransactions: [
                            {
                                unsignedTx: swapTransactions === null || swapTransactions === void 0 ? void 0 : swapTransactions[0],
                                network: swapTransactions === null || swapTransactions === void 0 ? void 0 : swapTransactions[0].chainId,
                                hash: executionHash,
                            },
                        ],
                        approvalTransactions: approvalTransactions.map(function (x) {
                            return {
                                unsignedTx: x,
                                network: x.chainId,
                                hash: approvalHash_1,
                            };
                        }),
                    };
                    console.log("Executing order EVM ".concat(orderType, " client side"), executionResponse, hash, decodedResponse);
                    return [3 /*break*/, 18];
                case 10:
                    if (!(orderType == 'SWAP_SINGLE' || orderType == 'WITHDRAW')) return [3 /*break*/, 17];
                    paramsToUse = params;
                    allowanceTransactions = [];
                    swapTransaction = void 0;
                    console.log('Executing order EVM SWAP_SINGLE client side', paramsToUse, orderType);
                    if (orderType == 'WITHDRAW') {
                        allowanceTransactions = (paramsToUse === null || paramsToUse === void 0 ? void 0 : paramsToUse.allowanceTx)
                            ? [paramsToUse === null || paramsToUse === void 0 ? void 0 : paramsToUse.allowanceTx]
                            : [];
                        swapTransaction = paramsToUse === null || paramsToUse === void 0 ? void 0 : paramsToUse.transferTx;
                    }
                    else {
                        allowanceTransactions =
                            ((_m = paramsToUse === null || paramsToUse === void 0 ? void 0 : paramsToUse.transactionData) === null || _m === void 0 ? void 0 : _m.allowance) || [];
                        swapTransaction = (_o = paramsToUse === null || paramsToUse === void 0 ? void 0 : paramsToUse.transactionData) === null || _o === void 0 ? void 0 : _o.swap;
                    }
                    if (!swapTransaction) {
                        throw new Error('Quote Generation Error');
                    }
                    console.log('Executing order EVM SWAP_SINGLE client side', allowanceTransactions, swapTransaction);
                    if (!!skipSimulation) return [3 /*break*/, 12];
                    return [4 /*yield*/, simulateEVMTransactionsClient({
                            network: swapTransaction.chainId,
                            transactions: __spreadArray(__spreadArray([], allowanceTransactions, true), [swapTransaction], false),
                        })];
                case 11:
                    simulateResult = _u.sent();
                    if (!(simulateResult === null || simulateResult === void 0 ? void 0 : simulateResult.simsPassed) || (simulateResult === null || simulateResult === void 0 ? void 0 : simulateResult.status) == 'error') {
                        throw new Error("Simulation Error: ".concat(simulateResult === null || simulateResult === void 0 ? void 0 : simulateResult.error));
                    }
                    _u.label = 12;
                case 12:
                    delete swapTransaction.from;
                    allowanceTransactions.forEach(function (x) {
                        delete x.from;
                    });
                    swapTransaction.value = swapTransaction.value ? BigInt(swapTransaction.value) : BigInt(0);
                    console.log('Executing order EVM SWAP_SINGLE client side', simulateResult, swapTransaction);
                    executionResponseError = null;
                    console.log('Executing order EVM SWAP_SINGLE client side', allowanceTransactions, swapTransaction);
                    _u.label = 13;
                case 13:
                    _u.trys.push([13, 15, , 16]);
                    return [4 /*yield*/, executeDirectTransactionsEVM({
                            transactions: __spreadArray(__spreadArray([], allowanceTransactions, true), [swapTransaction], false),
                            network: swapTransaction === null || swapTransaction === void 0 ? void 0 : swapTransaction.chainId,
                            wallet: signer,
                            blockConfirmations: 0,
                            legacyPayloads: __spreadArray(__spreadArray([], allowanceTransactions === null || allowanceTransactions === void 0 ? void 0 : allowanceTransactions.map(function (x) {
                                if (x.chainId == ChainId.ETHEREUM || true) {
                                    return {
                                        gasPrice: x.gasPrice,
                                        gasLimit: x.gasLimit,
                                    };
                                }
                                else {
                                    return undefined;
                                }
                            }), true), [
                                (swapTransaction === null || swapTransaction === void 0 ? void 0 : swapTransaction.chainId) == ChainId.ETHEREUM || true
                                    ? { gasPrice: swapTransaction.gasPrice, gasLimit: swapTransaction.gasLimit }
                                    : undefined,
                            ], false).filter(function (x) { return x; }),
                        })];
                case 14:
                    executionResponse = _u.sent();
                    if (!((_p = executionResponse === null || executionResponse === void 0 ? void 0 : executionResponse[0]) === null || _p === void 0 ? void 0 : _p.transactionHash)) {
                        throw new Error('Error executing transaction');
                    }
                    return [3 /*break*/, 16];
                case 15:
                    e_2 = _u.sent();
                    throw new Error("Error executing transaction: ".concat(e_2.message));
                case 16:
                    approvalHash_2 = (allowanceTransactions === null || allowanceTransactions === void 0 ? void 0 : allowanceTransactions.length)
                        ? (_q = executionResponse === null || executionResponse === void 0 ? void 0 : executionResponse[0]) === null || _q === void 0 ? void 0 : _q.transactionHash
                        : null;
                    executionResponseHash = ((_r = executionResponse === null || executionResponse === void 0 ? void 0 : executionResponse[1]) === null || _r === void 0 ? void 0 : _r.transactionHash) || ((_s = executionResponse === null || executionResponse === void 0 ? void 0 : executionResponse[0]) === null || _s === void 0 ? void 0 : _s.transactionHash);
                    console.log('Executing order EVM hashes', approvalHash_2, executionResponseHash, executionResponse);
                    if (orderType == 'WITHDRAW') {
                        decodedResponse = {
                            type: orderType,
                            status: executionResponseError ? 'error' : 'success',
                            error: executionResponseError,
                            note: 'Client side execution',
                            quoteId: params === null || params === void 0 ? void 0 : params.quoteId,
                            quote: params,
                            allowanceTransaction: allowanceTransactions.map(function (x) {
                                return {
                                    unsignedTx: x,
                                    network: x.chainId,
                                    hash: approvalHash_2,
                                    status: 'success',
                                };
                            })[0],
                            transferTransaction: {
                                unsignedTx: swapTransaction,
                                network: swapTransaction.chainId,
                                hash: executionResponseHash,
                                status: 'success',
                            },
                            simulateResult: simulateResult,
                        };
                    }
                    else {
                        decodedResponse = {
                            type: orderType,
                            status: executionResponseError ? 'error' : 'success',
                            error: executionResponseError,
                            note: 'Client side execution',
                            quoteId: params.quoteId,
                            quote: params,
                            swapTransaction: {
                                unsignedTx: swapTransaction,
                                network: swapTransaction.chainId,
                                hash: executionResponseHash,
                                status: 'success',
                            },
                            approvalTransactions: allowanceTransactions.map(function (x) {
                                return {
                                    unsignedTx: x,
                                    network: x.chainId,
                                    hash: approvalHash_2,
                                    status: 'success',
                                };
                            }),
                            simulateResult: simulateResult,
                        };
                    }
                    console.log('Executing order EVM SWAP_SINGLE output client side', orderType, executionResponse, hash);
                    return [3 /*break*/, 18];
                case 17:
                    if (orderType == 'SWAP_GENIUS') {
                        //to be implemented
                    }
                    else {
                        throw new Error('Order Type does not exist');
                    }
                    _u.label = 18;
                case 18:
                    executionTime = new Date().getTime() - startTime;
                    if (additionalExecutionTime) {
                        executionTime += additionalExecutionTime;
                    }
                    if (additionalDecodedResponse) {
                        decodedResponse['sponsorTransactions'] =
                            (additionalDecodedResponse === null || additionalDecodedResponse === void 0 ? void 0 : additionalDecodedResponse.sponsorTransactions) ||
                                (additionalDecodedResponse === null || additionalDecodedResponse === void 0 ? void 0 : additionalDecodedResponse.sponsorTransaction);
                        decodedResponse['sponsorTransaction'] =
                            (additionalDecodedResponse === null || additionalDecodedResponse === void 0 ? void 0 : additionalDecodedResponse.sponsorTransactions) ||
                                (additionalDecodedResponse === null || additionalDecodedResponse === void 0 ? void 0 : additionalDecodedResponse.sponsorTransaction);
                    }
                    result['decodedResponse'] = decodedResponse;
                    result['executionTime'] = executionTime;
                    result['status'] = decodedResponse.status;
                    return [4 /*yield*/, createDBOrderHistory(deepConvertBigInt({
                            order_id: dbOrder.id,
                            cloud_wallet_address: pkp.additionalEthAddress,
                            status: decodedResponse.error ? 'error' : 'success',
                            //@ts-ignore
                            result: result,
                            token_prices: tokenPrices,
                            orchestrator_pkp: params === null || params === void 0 ? void 0 : params.orchestratorPKP,
                            token_out_prices: toAssetPriceData,
                            execution_time: executionTime,
                            pkp_eth_address: pkp === null || pkp === void 0 ? void 0 : pkp.ethAddress,
                        }))];
                case 19:
                    dbOrderHistory = (_u.sent()).data;
                    console.log('Executing order EVM dbOrderHistory=>', dbOrderHistory);
                    if (decodedResponse.status == 'success') {
                        try {
                            executorUrl = (_t = getUrls()) === null || _t === void 0 ? void 0 : _t.EXECUTOR_URL;
                            console.log('Executing order EVM executorUrl', executorUrl);
                            updateUrl = "/api/forwardGet?target=".concat(executorUrl, "/api/order/update-user-order?order_id=").concat(dbOrder.id, "&cloud_wallet=").concat(pkp.additionalEthAddress);
                            console.log('Executing order EVM updateUrl=>', updateUrl);
                            fetch(updateUrl);
                        }
                        catch (e) {
                            console.log('Executing order EVM calling update url failed', e);
                        }
                    }
                    console.log('Executing order EVM client side', result, executionTime);
                    return [2 /*return*/, {
                            result: result,
                            dbOrderHistory: dbOrderHistory,
                            dbOrder: dbOrder,
                            time: executionTime,
                            litNetwork: ENV_LIT_NETWORK,
                        }];
                case 20:
                    e_3 = _u.sent();
                    throw e_3;
                case 21: return [2 /*return*/];
            }
        });
    });
}
